import React from "react";
import "./ServicesSection.css";
// Importing the image you uploaded
import billPaymentImg from "../bill payment.jpg"; 
import moneytran from "../moneytran.jpg"; 
import swipe from "../swipe.jpeg"; 

const services = [
  {
    image:swipe, // Credit Card Swipe
    title: "Credit Card Swiping",
    description: "Swipe your Visa, RuPay, or MasterCard at just 1.79% - 1.98%. Lowest rates guaranteed.",
    highlight: "From 1.79%",
  },
  {
    image: moneytran, // Money/Transfer
    title: "Instant Cash Transfer",
    description: "Get cash transferred directly to your bank account within 5 minutes of swiping.",
    highlight: "5 Min Transfer",
  },
  {
    image: billPaymentImg, // Your uploaded image
    title: "Bill Payment Service",
    description: "We pay your credit card bills on time. Never miss a due date again. Minimum service charges.",
    highlight: "On-Time Payment",
  },
];

const ServicesSection = () => {
  return (
    <section className="services-section">
      <div className="services-container">
        
        <div className="services-header fade-in-up">
          <h2 className="services-title gold-gradient-text">Our Premium Services</h2>
          <p className="services-subtitle">Trusted by thousands across Chennai</p>
        </div>

        <div className="services-grid">
          {services.map((service, i) => (
            <div 
              key={service.title} 
              className="service-card fade-in-up"
              style={{ animationDelay: `${i * 0.2}s` }}
            >
              <div className="service-highlight">
                {service.highlight}
              </div>
              
              {/* Image Section */}
              <div className="service-image-container" style={{ height: "180px" }}>
                <img src={service.image} alt={service.title} className="service-img" />
              </div>
              
              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-card-desc">{service.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ServicesSection;